import _ from 'lodash';
import postal from 'postal';

export default function showModal(type, data) {
  const isValidType = _.indexOf(['sign-up', 'sign-in'], type) >= 0;
  return event => {
    event && event.preventDefault();
    if (isValidType) {
      postal.publish({
        channel: `commands.${type}`,
        topic: 'present',
        ...(data ? { data } : {}),
      });
    }
  };
}
